import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { CSVExport } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit';
import Modal from 'react-bootstrap/Modal';
import { useHistory } from "react-router-dom";
import PopupFiltre from "./PopupFiltre";
export default function ListProvidersDataGrid({ providers, deleteProvider, setShow, show, setProviders, getProviders }) {
  let history = useHistory();
  const { ExportCSVButton } = CSVExport;
  const options = {
    sizePerPage: 50,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: false
  };
  const [id, setId] = useState();
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [eachEntry, setEachEntry] = useState("");
  const [showfiltre, setShowfiltre] = useState(false);
  const [initialProvider, setInitialProvider] = useState([]);
  const uri = process.env.REACT_APP_BASE_URL;
  const tableRowEvents = {
    onClick: (e, row, rowIndex) => {
      history.push("/admin/prestataire/" + row.id);

    },
  }
  const handleClosefiltre = (obj) => {
    setShowfiltre(false);
    //  searchwithfiltre(obj);
  };
  const handleShowfiltre = () => {
    setShowfiltre(true);
  };
  function searchwithfiltre(val) {
    setInitialProvider(providers);
    setEachEntry(val);
    console.log(val)
    if (val.name === ""
      && val.pays === ""
      && val.tel === ""
      && val.email === "" && val.contact === "") {

      getProviders();
      //  setParticipant(initialparticipant)
    } else {
      setProviders([]);
      // let providersFilter = providers.filter(el =>
      //   (el?.name?.toLowerCase().includes(val.name.toLowerCase()) && (val.name.length > 0))
      //   || (el?.country.toLowerCase() === val.pays.toLowerCase() && (val.pays.length > 0))
      //   || (el?.email?.toLowerCase().includes(val.email.toLowerCase()) && (val.email.length > 0))
      //   || el?.tel === val.tel
      // )

      let locationFilter = providers.filter(el => {
        let ch = 0; let lf; let i = 0;
        if (val.name) {
          i = i + 1
          lf = el?.name?.toLowerCase().includes(val?.name?.toLowerCase())
          if (lf) ch = ch + 1;
        }
        if (val.pays) {
          i = i + 1
          lf = el?.country?.toLowerCase().includes(val?.pays?.toLowerCase())
          if (lf) ch = ch + 1;
        }
        if (val.tel) {
          i = i + 1
          lf = el?.tel?.toLowerCase().includes(val?.tel?.toLowerCase())
          if (lf) ch = ch + 1;
        }
        if (val.email) {
          i = i + 1
          lf = el?.email?.toLowerCase().includes(val?.email?.toLowerCase())
          if (lf) ch = ch + 1;
        }
        if (val.contact) {
          i = i + 1
          lf = el?.contact_name?.toLowerCase().includes(val?.contact?.toLowerCase())
          if (lf) ch = ch + 1;
        }

        if (ch === i) { return true }
        return false
      })
     
        setProviders(locationFilter)

    }

  }
  const columns = [
    {
      dataField: "ref",
      text: "ref",
      csvText: "ref",
      hidden: "true",
    },
    {
      dataField: "name",
      text: "Nom",
      csvText: "name",
      sort: true,

    },
    {
      dataField: "address",
      text: "address",
      csvText: "address",
      sort: true,
      hidden: true
    },
    {
      dataField: "country",
      text: "Pays",
      csvText: "country",
      sort: true,
    },
    {
      dataField: "contact_name",
      text: "Contact",
      sort: true,
      csvText: "contact_name",

    },
    {
      dataField: "contact_surname",
      text: "contact_surname",
      sort: true,
      csvText: "contact_surname",
      hidden: true
    },
    {
      dataField: "comment",
      text: "comment",
      sort: true,
      csvText: "comment",
      hidden: true
    },
    {
      dataField: "zip",
      text: "zip",
      sort: true,
      csvText: "zip",
      hidden: true
    },
    {
      dataField: "tel",
      text: "Téléphone",
      sort: true,
      csvText: "tel",

    },
    {
      dataField: "city",
      text: "city",
      sort: true,
      csvText: "city",
      hidden: true
    },
    {
      dataField: "website",
      text: "website",
      sort: true,
      csvText: "website",
      hidden: true
    },
    {
      dataField: "email",
      text: "Email",
      csvText: "email",
      sort: true,
    },
    {
      dataField: "follow",
      text: "",
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
          e.stopPropagation();
        },
      },
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return (
          <div
            className="btn-group float-end"
            role="group"
            aria-label="Basic example"
          >
            <a
              href={"/admin/prestataire-edit/" + row.id}
              type="button"
              className="btn btn-link"
            >
              <img
                src={require("../../../../assets/icons/edit.png")}
              />
            </a>

            {localStorage.getItem("role") === "Super-admin" ? (
              <button
                type="button"
                className="btn"
                onClick={() => {
                  setId(row.id);
                  handleShow();
                }}
              >
                <img
                  src={require("../../../../assets/icons/delete.png")}
                />
              </button>
            ) : (
              ""
            )}
          </div>
        );
      },
      sort: true
    },
  ];
  const selectRow = {
    mode: 'checkbox',
    clickToSelect: true,
    // hideSelectAll: true,
  };

  const MyExportCSV = (props) => {
    const handleClick = () => {
      props.onExport();
    };
    return (
      <div>
        <button className="hidden" hidden onClick={handleClick} name="export" id="export">Export to CSV</button>
      </div>
    );
  };
  let rows = providers.map((item, i) => item);
  return (
    <ToolkitProvider
      keyField="id"
      data={rows}
      columns={columns}
      exportCSV={{ onlyExportSelection: true, exportAll: false }}
      search
    >
      {
        (props) => (
          <div>
            <MyExportCSV {...props.csvProps} />
            <div className="lists-filter my-3">
              <div className="row">
                <div className="col-xl-4 col-lg-1"></div>
                <div className="col-xl-8 col-lg-11 col-md-12 col-xs-12">
                  <div className="flexgy">
                    <div className="col-md-4  mr-1  px-0">
                      <div className="input-group">
                        <input
                          className="form-control height43"
                          type="search"
                          placeholder="Recherche"
                          onChange={(e => props.searchProps.onSearch(e.target.value))}

                        />
                      </div>
                    </div>
                    <div className=" px-0 myxs ">
                      <div className="flex">
                        <div className="square">
                          <button
                            type="button"
                            className="btn btn-link"
                            onClick={handleShowfiltre}
                          >
                            <img
                              src={require("../../../../assets/icons/filter.png")}
                              title="Filtrer"
                            />
                          </button>
                          <PopupFiltre
                            showfiltre={showfiltre}
                            closefiltre={handleClosefiltre}
                            searchwithfiltre={searchwithfiltre}
                            filterEntry={eachEntry}
                          />
                        </div>
                        <div className="square">
                          <button type="button" className="btn btn-link" onClick={() => props.csvProps.onExport()}>
                            <img
                              src={require("../../../../assets/icons/Export.png")}
                              title="Export"
                            />
                          </button>
                        </div>
                        <input
                          type="file"
                          name="file"
                          id="file"
                          accept={".csv"}
                          className="btn btn-link"
                          // onChange={handleOnChange}
                          hidden
                        />
                        <div className="square">
                          <label for="file" type="button">
                            <img
                              src={require("../../../../assets/icons/Import.png")}
                            />
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="px10">
                      <div className="d-grid gap-2">
                        <a
                          href="/admin/create-prestataire"
                          className="btn btn-primary height43"
                          type="button"
                        >
                          Ajouter un prestataire
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <BootstrapTable
              data={providers}
              {...props.baseProps}
              classes="table-dark mt-5"
              bordered={false}
              hover
              selectRow={selectRow}
              pagination={paginationFactory(options)}
              rowEvents={tableRowEvents}
            />
            <Modal show={show} onHide={handleClose} className="provider">
              <Modal.Header closeButton>
                <Modal.Title className="modaltitle">Etes-vous sûr(e) de vouloir supprimer </Modal.Title>
              </Modal.Header>

              <Modal.Footer>
                <Button variant="" onClick={handleClose} style={{ color: "#006FFF" }}>
                  Annuler
                </Button>
                <Button
                  type="button"
                  variant="btn btn-primary"
                  onClick={(e) => deleteProvider(id)}>
                  Valider
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
        )
      }
    </ToolkitProvider>

  );
}